import { render, staticRenderFns } from "./S2_P1_PersonalData.vue?vue&type=template&id=b4db1316&scoped=true&"
import script from "./S2_P1_PersonalData.vue?vue&type=script&lang=js&"
export * from "./S2_P1_PersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4db1316",
  null
  
)

export default component.exports